import { render, staticRenderFns } from "./CollageViewer.vue?vue&type=template&id=e0c2808a&scoped=true&"
import script from "./CollageViewer.vue?vue&type=script&lang=js&"
export * from "./CollageViewer.vue?vue&type=script&lang=js&"
import style0 from "./CollageViewer.vue?vue&type=style&index=0&id=e0c2808a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c2808a",
  null
  
)

export default component.exports